// 🔁 The card's reshare-pool marker (owner 2026-10-27 "add marker on our desk on the listing being in reshare pool",
// pointed at the price line next to ლიდი). Shows: in a pool → "Pool"; our reposts in 30 days → "3× by 2"; a push row open
// → "Queued now" (amber). The tooltip names the pools / queue reasons. Nothing in a pool and no reposts → nothing renders.
import { memo } from 'react'
import { Icon } from '../Icon.jsx'
import { t } from '../../lib/i18n.js'
import { useReshareStatus } from './reshareStatus.js'

const POOL_KEY = { confirmed: 'desk_pool_confirmed', outside: 'desk_pool_outside', coop: 'desk_pool_coop', front_page: 'desk_pool_front_page' }
const PUSH_KEY = { chase: 'desk_push_chase', front_page: 'desk_push_front_page' }

export const ReshareMark = memo(function ReshareMark({ propertyId }) {
  const s = useReshareStatus(propertyId)
  if (!s) return null
  const pools = s.pools || [], push = s.push || []
  if (!pools.length && !push.length && !s.reposts) return null
  const lines = []
  if (pools.length) lines.push(t('desk_reshare_hint_pools').replace('{list}', pools.map(p => t(POOL_KEY[p] || p)).join(', ')))
  if (s.reposts) lines.push(t('desk_reshare_hint_reposts').replace('{n}', s.reposts).replace('{a}', s.accounts)
    .replace('{at}', s.last_at ? new Date(s.last_at).toLocaleString() : '?'))
  if (push.length) lines.push(t('desk_reshare_hint_queued').replace('{list}', push.map(x => {
    const [why, portal] = String(x).split(':'); return `${portal} (${t(PUSH_KEY[why] || why)})`
  }).join(', ')))
  return (
    <span className={`text-xs font-medium inline-flex items-center gap-1 ${push.length ? 'text-amber-600 dark:text-amber-400' : 'text-sky-600 dark:text-sky-400'}`}
      title={lines.join('\n')}>
      <Icon name="repeat" size={12} />
      {push.length ? t('desk_reshare_queued') : pools.length ? t('desk_reshare_badge') : null}
      {s.reposts > 0 && <span className="tabular-nums">{t('desk_reshare_reposts').replace('{n}', s.reposts).replace('{a}', s.accounts)}</span>}
    </span>
  )
})
